import { InjectionToken, Signal, signal } from '@angular/core';

const defaultLanguageCode = 'en-GB';

export const SURVEY_DEFAULT_LANGUAGE_CODE = new InjectionToken<Signal<string>>('SURVEY_DEFAULT_LANGUAGE_CODE', {
  factory: (): Signal<string> => signal(defaultLanguageCode)
});
